"use client"

import { useState, useEffect, useRef } from "react"

export function TypingText({
  text,
  speed = 30,
  onComplete,
}: {
  text: string
  speed?: number
  onComplete?: () => void
}) {
  const [displayed, setDisplayed] = useState("")
  const [done, setDone] = useState(false)
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  useEffect(() => {
    setDisplayed("")
    setDone(false)
    let i = 0
    const interval = setInterval(() => {
      if (i < text.length) {
        setDisplayed(text.slice(0, i + 1))
        i++
      } else {
        clearInterval(interval)
        setDone(true)
        onCompleteRef.current?.()
      }
    }, speed)
    return () => clearInterval(interval)
  }, [text, speed])

  return (
    <span className="relative">
      {displayed}
      {!done && (
        <span
          className="inline-block w-0.5 h-[1em] bg-primary animate-pulse align-text-bottom"
          style={{ marginRight: "-0.125rem" }}
          aria-hidden
        />
      )}
    </span>
  )
}
